import StoreService from '../services/store';
import * as types from 'constants/ActionTypes';
import { showSnackbar } from './utils';
import {
  isSessionDeprecated,
  getNewToken,
} from './sessions';

export const updateStore = (data, token) => async dispatch => {
  data.lat = data.address_lat ? data.address_lat : data.lat;
  data.lon = data.address_lon ? data.address_lon : data.lon;
  const adr = {
    address_print: typeof data.address === "object" ? data.address.address_print : data.address,
    address_street: null,
    address_zipcode: typeof data.address === "object" ? data.address.address_zipcode : data.zip_code,
    address_city: null,
    address_country: null
  }
  delete data.address;
  delete data.zip_code;
  data.address = adr;
  data.description = data.description + "\n" + data.specialkey;
  delete data.address_lat;
  delete data.address_lon;
  delete data.specialkey;

  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.update(data, token)
  .then(() => {
    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    return dispatch({
      type: types.UPDATE_STORE,
      data
    })
  })
  .catch(() => {
    showSnackbar(dispatch, "Error on store data save");
  });
}

export const getStore = (id, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.getStore(id, token)
  .then(response => {
    const { data } = response;
    return dispatch({
      type: types.GET_STORE,
      data
    })
  })
  .catch(err => {
    console.log('get store');
  });
}

export const getHome = (token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  dispatch({
    type: types.IS_OPENING_HOME,
  });

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.getHome(token)
  .then(response => {
    const { data } = response;
    return dispatch({
      type: types.GET_HOME,
      data
    })
  })
  .catch(err => {
    console.log('get store');
  });
}

export const cleanHome = () => async dispatch => {
  dispatch({
    type: types.CLEAN_HOME,
  })
}

export const postLogo = (id, data, config, token, params = {}) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  return StoreService.postLogo(data, config, token)
  .catch(err => {
    console.log('error');
    console.log(err);
  });
}

export const postCover = (id, data, config, token, params = {}) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  return StoreService.postCover(data, config, token)
  .catch(err => {
    console.log('error');
    console.log(err);
  });
}

export const updateLogo = (urlImage) => dispatch => {
  return dispatch({
    type: types.UPDATE_LOGO,
    urlImage
  });
}

export const getBilling = (id, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.getBilling(id, token)
  .then(response => {
    const data = response.data;
    return dispatch({
      type: types.GET_BILLING,
      data
    })
  })
  .catch(err => {
    console.log('get billing');
  });
}

export const getNotifications = (id, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.getNotifications(id, token)
  .then(response => {
    const data = response.data;
    return dispatch({
      type: types.GET_NOTIFICATIONS_EDIT,
      data
    })
  })
  .catch(err => {
    console.log(err);
  });
}

export const postNotification = (data, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.postNotification(data, token)
  .then((response) => {
    const responseData = response.data;

    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    return dispatch({
      type: types.POST_NOTIFICATION,
      data: responseData,
    })
  })
  .catch(() => {
    showSnackbar(dispatch, "Error to post notification");
  });
}

export const postBilling = (id, data, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (data.app_fee) {
    delete data.app_fee;
  }
  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.postBilling(id, data, token)
  .then(() => {
    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    return dispatch({
      type: types.POST_BILLING,
      data
    })
  })
  .catch(() => {
    showSnackbar(dispatch, "Error to post billing");
  });
}

export const postAdmin = (data, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.postAdmin(data, token)
  .then(() => {
    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    return dispatch({
      type: types.POST_ADMIN,
      data
    })
  })
  .catch(() => {
    showSnackbar(dispatch, "Error to post admin info");
  });
}

export const updateTerms = (date, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.updateTerms(date, token)
  .then(() => {
    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    return dispatch({
      type: types.UPDATE_TERMS,
      data: date,
    })
  })
  .catch(() => {
    showSnackbar(dispatch, "Error in update terms");
  });
}

export const updateAdminStore = (data, token) => async dispatch => {
  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.updateAdminStore(data, token)
  .then(() => {
    showSnackbar(dispatch, types.MESSAGE_OK, "success");
    window.location.reload()
  })
  .catch(() => {
    showSnackbar(dispatch, "Error in update Admin store");
  });
}

export const setNotifications = (data) => async dispatch => {
  return dispatch({
    type: types.GET_NOTIFICATIONS,
    data
  });
}

export const addNotification = (data) => async dispatch => {
  return dispatch({
    type: types.ADD_NOTIFICATION,
    data
  });
}

export const subscriberToTopic = (token, storeId, deviceToken, topic = 'topic_storeadmin') => async dispatch => {
  const storeTopic = `${topic}_${storeId}`;

  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  StoreService.subscriberToTopic(token, deviceToken, storeTopic)
    .then(() => {
    showSnackbar(dispatch, "Subscribed to notifications", "success");
  })
  .catch(() => {
    showSnackbar(dispatch, "Error in subscribed to notifications");
    });
}

export const unSubscriberToTopic = (token, storeId, deviceToken, topic = 'topic_storeadmin') => async dispatch => {
  const storeTopic = `${topic}_${storeId}`;

  const isTokenDeprecated = isSessionDeprecated();

  if (isTokenDeprecated) {
    token = await getNewToken(dispatch);
  }

  return StoreService.unSubscriberToTopic(token, deviceToken, storeTopic)
    .then(() => {
      console.info('Unsubscribed to notifications');
  })
}

